import React from "react";
import { string, arrayOf, shape, bool } from "prop-types";
import { Link } from "@quintype/components";

import { STATIC_KEYWORDS } from "../../../constants";
import { getTemplateName } from "../../utils";
import { getCategoryAndSubCategory } from "../../../ga-utils";

import "./NavSubMenu.m.css";

const NavSubMenu = ({ subMenuitems, customStyleName, isActive, parentMenuName, story, config, pageType }) => {
  const { MENU_ITEM } = STATIC_KEYWORDS;
  return (
    <ul className="sub-menu" styleName={`sub-menu ${customStyleName} ${isActive ? "active" : "inactive"}`}>
      {subMenuitems?.map(({ completeUrl, title }, index) => {
        const handleSubMenuClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.dataLayer = window.dataLayer || [];
          let categoryInfo = getCategoryAndSubCategory(window.location, pageType, config, story);

          window.dataLayer.push({
            event: "dl_menu_click",
            link_url: completeUrl || "#",
            link_text: title.toLowerCase(),
            link_category: parentMenuName.toLowerCase(),
            category: categoryInfo.category,
            sub_category: categoryInfo.subCategory,
            content_id: categoryInfo.contentId,
            template_name: getTemplateName(story?.["story-template"] || pageType),
            platform: window.innerWidth >= 768 ? "desktop" : "mobile",
            eventCallback: function () {
              window.location.href = completeUrl || "#";
            },
          });
        };

        return (
          <li styleName="sub-item" key={`${title}-${index}`}>
            <div onClick={handleSubMenuClick} style={{ display: "contents" }}>
              <Link href={completeUrl || "#"} className="link" disableAjaxLinks={true}>
                {title || MENU_ITEM}
              </Link>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

NavSubMenu.defaultProps = {
  subMenuitems: [],
  customStyleName: "",
  parentMenuName: "",
};

NavSubMenu.propTypes = {
  subMenuitems: arrayOf(
    shape({
      completeUrl: string,
      title: string,
    })
  ).isRequired,
  customStyleName: string,
  isActive: bool,
  parentMenuName: string,
};

export default NavSubMenu;
